import type { InspectionTemplate } from 'inspection-types';
import { compareUUIDs } from 'uuid-encoding';

import type { InspectionsChannel } from '../types/channel';

/**
 * Returns true when the template is owned by the given channel.
 *
 * The channel id and the template's buildingId.entityId may be in different
 * encodings (UUID base16 or base62) depending on where they were fetched from.
 * We rely on compareUUIDs to normalise both sides before comparing.
 */
export function isTemplateOwnedByChannel(
  template: Pick<InspectionTemplate, 'metadata'>,
  channel: Pick<InspectionsChannel, '_id'>
): boolean {
  const buildingEntityId = template.metadata.buildingId?.entityId;

  if (!buildingEntityId || !channel._id) {
    return false;
  }

  return compareUUIDs(buildingEntityId, channel._id);
}
